import request from "./client";

export const transcribeAudio = async (audioBlob) => {
  const resp = await request.post("/v1/transcriptions").attach("file", audioBlob, "recording.webm");
  return resp.body;
};
